export const FORM_BARCODE = ({ onEnter }) => {
  return [
    {
      name: 'barcode',
      label: 'รหัสบาร์โค้ด',
      placeholder: '0 9 5 8 1 2 3 4 8',
      type: 'INPUT_BARCODE_AUTO',
      rules: {
        required: true,
      },
      maxLength: 16,
      onEnter,
      style: { textAlign: 'center' },
      inputStyle: { textAlign: 'center' },
    },
  ];
};


export const FORM_QR_CODE = ({ onEnter, required = true }) => {
  return [
    {
      name: 'qrCode',
      label: 'รหัสรับประกันสินค้า',
      type: 'INPUT_QR_CODE',
      rules: {
        required,
      },
      maxLength: 16,
      onEnter,
      style: { textAlign: 'center' },
      inputStyle: { textAlign: 'center' },
      placeholder: 'กรอกรหัสรับประกันสินค้า',
    },
  ];
};
